<aside class="sidebar" data-testid="app-sidebar">
  <div class="sidebar__search">
    <div class="search-input">
      <img class="search-input__icon" src="assets/design-system/icons/20/search.svg" alt="" aria-hidden="true" />
      <input
        type="search"
        class="search-input__field ds-text-field-s not-icon"
        placeholder="Filter tree..."
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearch($event)"
        data-testid="input-search"
      />
    </div>
  </div>

  <div class="sidebar__header">
    <span class="sidebar__header-title">Source</span>
    <div class="sidebar__header-actions">
      <button
        type="button"
        ds-button
        class="sidebar__header-btn ds-button-xs icon-button"
        [class.sidebar__header-btn--active]="selectMode()"
        [class.ds-button-secondary]="selectMode()"
        [class.ds-button-secondary-subtle]="!selectMode()"
        (click)="toggleSelectMode()"
        title="Toggle multi-select mode"
        data-testid="button-toggle-select"
      >
        <ds-icon name="row" sizeIcon="s" />
      </button>
      @if (authService.isEditor()) {
        <button
          type="button"
          ds-button
          class="sidebar__header-btn ds-button-xs icon-button ds-button-secondary-subtle"
          (click)="openCreateModal()"
          title="Add new folder or table"
          data-testid="button-add-item"
        >
        <ds-icon name="add" sizeIcon="s" />
        </button>
      }
    </div>
  </div>

  <div class="sidebar__tree scrollbar-thin" data-testid="hierarchy-tree">
    @if (loading()) {
      <div class="sidebar__loading">
        <div class="loading-spinner"></div>
      </div>
    } @else if (filteredHierarchy().length === 0) {
      <div class="sidebar__empty">
        <p>No results found</p>
      </div>
    } @else {
      @for (node of filteredHierarchy(); track hierarchyRowKey(node)) {
        <app-tree-node
          [node]="node"
          [level]="0"
          [isEditor]="authService.isEditor()"
          [selectionTarget]="selectionTarget()"
          [showCheckboxes]="selectMode()"
          (nodeClick)="trackSidebarOpen($event); onNodeClick($event)"
          (nodeToggle)="onNodeToggle($event)"
          (nodeEdit)="onNodeEdit($event)"
          (nodeDelete)="onNodeDelete($event)"
          (nodeSelect)="onNodeSelect($event)"
          (nodeAddChild)="onNodeAddChild($event)"
          (nodeMove)="onNodeMove($event)"
        />
      }
    }
  </div>

  <div class="sidebar__footer">
    @if (selectMode() && authService.isEditor() && exportSelectionService.hasSelection()) {
      <button
        type="button"
        ds-button
        class="ds-button-s ds-button-warning sidebar__delete-btn starting-icon-button"
        (click)="bulkDeleteSelectedDictionaries()"
        data-testid="button-bulk-delete-selected"
      >
        <ds-icon name="trash" sizeIcon="s" />
        Delete ({{ exportSelectionService.selectedCount() }})
      </button>
    }
    <button
      type="button"
      ds-button
      class="ds-button-s ds-button-tertiary-subtle starting-icon-button"
      (click)="sortAlphabetically()"
      data-testid="button-sort-alpha"
    >
      <img src="assets/design-system/icons/20/chevron-up-down.svg" alt="" aria-hidden="true" />
      Sort A-Z
    </button>
  </div>
</aside>

@if (showCreateModal()) {
  <app-create-item-modal
    [parentNode]="createModalParent()"
    [currentDepth]="createModalDepth()"
    (close)="closeCreateModal()"
    (create)="onCreateItem($event)"
  />
}
